import { defineComponent as _defineComponent } from 'vue'
import { BModal } from 'bootstrap-vue';
import { VanillaPriceResponse } from 'ah-api-gateways';
import OptionTermsheetViewer from 'ah-trades/src/components/OptionTermsheetViewer.vue';
import { watch, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OptionTermsheetModal',
  props: {
    solution: null
  },
  emits: ["update:pause"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'update:pause', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const modal = ref<InstanceType<typeof BModal> | null>(null);



const modalShown = ref<boolean>(false);



function show() {
  modalShown.value = true;
}

watch(modalShown, () => emit('update:pause', modalShown.value), { immediate: true });

expose({ show });

return { __sfc: true,modal, modalShown, emit, show, BModal, OptionTermsheetViewer }
}

})